import React from 'react';
import {Box} from '@mui/material';
import {FONT_SIZE, FONT_WEIGHT} from '@/utils/constants/globalStyle';
import {COLOR_CODE} from '@/utils/constants/colors';
import {Icon, LinkText} from '@/components/atoms';
import './_linkTextWithIcon.scss';
import PropTypes from 'prop-types';
/**
 * LinkTextWithIcon component renders a text link with an optional icon.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.id - The id for the link text.
 * @param {string} props.text - The text to display in the link.
 * @param {string} [props.fontSize=FONT_SIZE.SM] - The font size of the text.
 * @param {function} props.handleClick - The click handler function for the link.
 * @param {string} [props.iconName='open_in_new'] - The name of the icon to display.
 * @param {string} [props.iconSize='small'] - The size of the icon.
 * @param {boolean} [props.isIconVisible=false] - Flag to determine if the icon should be visible.
 *
 * @returns {JSX.Element} The rendered LinkTextWithIcon component.
 */
const LinkTextWithIcon = ({
  id,
  text,
  fontSize = FONT_SIZE.SM,
  handleClick,
  iconName = 'open_in_new',
  iconSize = 'small',
  isIconVisible = false
}) => {
  return (
    <Box className={`flex items-center `}>
      <LinkText
        isPaddingHidden={true}
        onClick={handleClick}
        text={text}
        fontWeight={FONT_WEIGHT.BOLD}
        fontColor={COLOR_CODE._3387DF}
        id={id}
        fontSize={fontSize}
      />
      {isIconVisible && (
        <Icon
          className={`ltwi-icon-color pl-1`}
          icon={iconName}
          size={iconSize}
        />
      )}
    </Box>
  );
};

LinkTextWithIcon.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  isIconVisible: PropTypes.bool
};

export default React.memo(LinkTextWithIcon);
